import Layout from "components/layout/Layout";
const CommunityGuidelines = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Community <span>Guidelines</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        Our community thrives on mutual respect and shared goals. Support and encourage one another, respect privacy, and focus on meaningful engagement. Together, we create a space where everyone can achieve their fitness and wellness aspirations.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <ol className="list-wrap">
                                        <li>
                                            <strong>
                                                1. Be Respectful and Inclusive
                                            </strong>
                                            <p>
                                                We celebrate diversity and are committed to maintaining an inclusive community. Treat everyone with respect, regardless of their background, fitness level, or opinions. Harassment, hate speech, and discrimination of any kind will not be tolerated.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                2. Encourage and Support Others
                                            </strong>
                                            <p>
                                                BodyLytiX is a space for growth and positivity. Offer encouragement, constructive feedback, and celebrate the achievements of others. Whether someone is a beginner or an expert, everyone deserves to feel valued and supported.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                3. Share Constructive Contributions
                                            </strong>
                                            <p>
                                                Keep discussions relevant, helpful, and focused on fitness, wellness, and the BodyLytiX platform. When sharing advice or feedback, ensure it’s constructive and based on personal experience or credible sources.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                4. Respect Privacy and Data
                                            </strong>
                                            <p>
                                                Protect your privacy and the privacy of others. Do not share personal or sensitive information about yourself or anyone else without consent. Avoid posting screenshots, data, or information that could identify another user.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                5. Avoid Spam and Self-Promotion
                                            </strong>
                                            <p>
                                                Our community is for meaningful engagement, not for spamming or unsolicited promotions. Refrain from posting irrelevant links, excessive self-promotion, or marketing content unrelated to BodyLytiX.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                6. Use Coaches Responsibly
                                            </strong>
                                            <p>
                                                When creating or sharing custom Coaches, ensure they are designed to support safe, effective, and inclusive fitness practices. Misleading, harmful, or inappropriate content will be removed.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                7. Follow Platform Rules
                                            </strong>
                                            <p>
                                                Adhere to the terms of service and privacy policies of BodyLytiX. Use the platform responsibly and report any bugs or issues to our support team.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                8. Report Inappropriate Behavior
                                            </strong>
                                            <p>
                                                Help us maintain a safe community by reporting inappropriate behavior, offensive content, or violations of these guidelines. You can report issues directly within the app or contact us at <a href="mailto:support@bodylytix.ai">
                                                    support@bodylytix.ai
                                                </a>.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                9. Be Patient and Kind
                                            </strong>
                                            <p>
                                                Remember that everyone’s fitness journey is unique. Show kindness and patience, whether someone is sharing progress, asking a question, or seeking advice.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>
                                                10. Stay Engaged and Informed
                                            </strong>
                                            <p>
                                                Stay active in the community by participating in discussions, sharing your experiences, and providing feedback. Engage respectfully and keep learning from others to enrich your fitness journey.
                                            </p>
                                        </li>
                                    </ol>
                                </div>
                                <div className="job-qualifications">
                                    <strong>Consequences for Violations</strong>
                                    <p className="info-one">
                                        Failure to adhere to these guidelines may result in content removal, account suspension, or permanent ban from the platform, depending on the severity of the violation. Our goal is to ensure a safe and positive experience for everyone.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        By participating in the BodyLytiX community, you contribute to a supportive and inspiring environment where everyone can achieve their fitness and wellness goals. Thank you for helping us build a community rooted in respect, encouragement, and growth.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default CommunityGuidelines;